import React, { useEffect } from "react";

const DropdownDoctorListing = ({
  defaultValue,
  label,
  labelFor,
  options,
  disabled,
  setValue,
}) => {
  const handleSelectChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ position: "relative", zIndex: "2" }}>
        {label && <label htmlFor={labelFor}>{label}</label>}
        <select
          className="form-select form-select-lg"
          aria-label=".form-select-lg"
          id={labelFor}
          value={defaultValue}
          onChange={handleSelectChange}
          style={{
            fontWeight: defaultValue ? "700" : "300",
            color: defaultValue ? "black" : "#A7A7A7",
          }}
          disabled={disabled}
        >
          <option value="" disabled selected={defaultValue ? false : true}>
            Select {label} (Option)
          </option>
          {options?.map((option, index) => (
            <option
              key={index}
              value={option.value ? option.value : option.label}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <img
        src="./img/icon/dropdown-icon.png"
        alt=""
        className="dropdown-icon-style"
      />
    </div>
  );
};

export default DropdownDoctorListing;
